<script>
import { uiState } from "@app/store/uiStore.js";
import {
    externalDataState
} from '@app/store/externalDataStore.js';
import {
    modalState
} from '@app/store/modalStore.js';
import ThemeMenu from "./menus/ThemeMenu.svelte";
/* import {
    projectState
} from '@app/store/projectStore.js'
import {environment} from '@app/store/envStore.js';
import FileMenu from './menus/FileMenu.svelte'; */
import EditMenu from './menus/EditMenu.svelte';
import FormatMenu from './menus/FormatMenu.svelte';
import TimecodeMenu from './menus/TimecodeMenu.svelte';
import InsertMenu from './menus/InsertMenu.svelte';
/* import AiToolsMenu from './menus/AiToolsMenu.svelte';
import TeamMenu from './menus/TeamMenu.svelte';
import HelpMenu from './menus/HelpMenu.svelte';
import CliMenu from './menus/CliMenu.svelte'; */

import { clickOutside } from "svelte-use-click-outside";
import Swal from 'sweetalert2';

let cachedMenu;
let menuState = {
    file: false,
    edit: false,
    format: false,
    timecode: false,
    insert: false,
    aiTools: false,
    team: false,
    help: false,
    drastic : false
};

function updateMenu(event) {
    setTimeout(() => {
        menuState[event.detail.menu] = !menuState[event.detail.menu];
        cachedMenu = event.detail.menu;
    }, 0);
}

function closeMenus(ev) {
    if (cachedMenu) {
        menuState = {
            file: false,
            edit: false,
            format: false,
            timecode: false,
            insert: false,
            aiTools: false,
            team: false,
            help: false,
            cli : false
        };
        cachedMenu = undefined;
    }
}

function escape(){
    Swal.fire({
        titleText: "Close Project",
        text : "Are you sure you wish to go back? All work will be lost. Please Save Work in order to keep your progress.",
        showCancelButton: true,
        confirmButtonText: 'Close Project',
        cancelButtonText: 'Continue Working',
        allowOutsideClick : false,
        allowEscapeKey : false,
        buttonsStyling : false,
        customClass: {
            confirmButton: 'btn btn-danger me-2',
            cancelButton: 'btn btn-outline-secondary',
        }
    }).then((result) => {
        if (result.isConfirmed) {
            console.info(`DEBUG: Navigating to ${$externalDataState.returnTo}.`);
            window.location.replace($externalDataState.returnTo);
        } else {
            return false;
        }
    }).catch(err =>{
        console.log(err);
        console.log(err.message)
    });
}
</script>

<svelte:body on:click={closeMenus} />
<nav 
    aria-label="Primary Toolbar"
    class="navbar navbar-expand bg-light shadow"
    style="height: 3vh;"
    use:clickOutside={closeMenus}
>
    <div class="container-fluid">
        <img class="navbar-brand" src="./trms-logo.svg" alt="TRMS Logo" height="30">
        <button data-toggle="collapse" class="navbar-toggler" data-target="#navcol-1"><span >Toggle navigation</span><span class="navbar-toggler-icon"></span></button>
        <div class="collapse navbar-collapse" id="navcol-1">
            <ul class="nav navbar-nav">
                <!-- <FileMenu currentState={menuState.file} on:toggleMenu={updateMenu}></FileMenu> -->
                <EditMenu currentState={menuState.edit} on:toggleMenu={updateMenu}></EditMenu>
                <FormatMenu currentState={menuState.format} on:toggleMenu={updateMenu}></FormatMenu>
                <TimecodeMenu currentState={menuState.timecode} on:toggleMenu={updateMenu}></TimecodeMenu>
                <InsertMenu currentState={menuState.insert} on:toggleMenu={updateMenu}></InsertMenu>
                <!-- <AiToolsMenu currentState={menuState.aiTools} on:toggleMenu={updateMenu}></AiToolsMenu> -->
                <!-- {#if $environment.electron}
                    <CliMenu currentState={menuState.cli} on:toggleMenu={updateMenu}></CliMenu>
                {/if}    -->       
                <!-- <HelpMenu currentState={menuState.help} on:toggleMenu={updateMenu}></HelpMenu> -->
            </ul>
            <ul class="nav navbar-nav ms-auto">                
                <ThemeMenu
                    currentState={menuState.theme}
                    on:toggleMenu={updateMenu}
                ></ThemeMenu>
                <li class="nav-item" title="Show/Hide Timeline">
                    <a
                        class="nav-link {$uiState.timeline
                            ? 'text-primary'
                            : 'text-muted'}"
                        href="#!/"
                        id="toggle-timeline"
                        aria-label="Show or hide timeline"
                        aria-pressed={$uiState.timeline}
                        role="button"
                        on:click={() =>
                            ($uiState.timeline = !$uiState.timeline)}
                        ><i class="bi bi-input-cursor" aria-hidden="true"></i></a
                    >
                </li>
                <!-- List Preview -->
                <li class="nav-item" title="Toggle Prev/Next Event View">
                    <a
                        class="nav-link {$uiState.listPreview
                            ? 'text-primary'
                            : 'text-muted'}"
                        href="#!/"
                        id="toggle-preview"
                        aria-label="Toggle previous and next event view"
                        aria-pressed={$uiState.listPreview}
                        role="button"
                        on:click={() =>
                            ($uiState.listPreview = !$uiState.listPreview)}
                        ><i class="bi bi-view-list" aria-hidden="true"></i>
                    </a>
                </li>
                <div class="vr align-self-center" role="separator"></div>
                <li class="nav-item" title="Publish"> 
                    <a class="nav-link fw-bold text-primary" href="#!/" on:click="{() => modalState.showModal('publishProjectCustom')}"><i class="bi bi-cloud-upload"></i> Save Work</a>
                </li>
                <li class="nav-item" title="Cancel"> 
                    <a class="nav-link fw-bold" href="#!/" on:click="{() => escape()}"><i class="bi bi-escape"></i> Cancel</a>
                </li>
                <!-- {#if $projectState.type === "team"}
                    <TeamMenu></TeamMenu>
                {/if}    
                <li class="nav-item" title="Live Support Chat"> 
                    <a class="nav-link" href="https://chatting.page/qaabxezhqhnaqf53cf3ylbzryxamrn8o" target="_blank" rel="noreferrer"><i class="bi bi-chat-right-dots"></i></a>
                </li> -->
            </ul> 
        </div>
    </div>
</nav>
